import { Routes } from './components/Routes';
import { DataFetchingClient, DataFetchingClientProvider } from 'data-fetching-client';
import { getLocaleInfo as getPortalsLocaleInfo, initializePortal } from 'portals-platform-lib';
import { jsx as _jsx } from "react/jsx-runtime";
const client = new DataFetchingClient();
export const prepareApp = async () => {
  try {
    await initializePortal({
      client
    });
  } catch (error) {
    console.error('Failed to fetch brand and theme data:', error);
  }
  return {};
};
export const getLocaleInfo = () => getPortalsLocaleInfo({
  client
});
export function AppComponent() {
  return /*#__PURE__*/_jsx(DataFetchingClientProvider, {
    client: client,
    children: /*#__PURE__*/_jsx("div", {
      "data-test-id": "app",
      children: /*#__PURE__*/_jsx(Routes, {})
    })
  });
}